<template id="source-modal-template">
  <base-form v-if="source" :do="save" :v-errors="error" class="flex flex-col" id="source-modal">
    <div class="modal-body content">
      <div class="group fields">
        <text-input class="w-full" label="Bron" name="source" type="text"
          v-model="source.name"
          v-validate="'required'"
          data-vv-as="Bron"
          :error="errors.first('source')"
          :has-permission="true"
          :required="true"
        ></text-input>

        <div class="flex flex-wrap w-full mx-0">
          <text-input class="w-full md:w-1/2" label="Ruimte" name="room" type="text"
            v-model="room.name"
            v-validate="'required'"
            data-vv-as="Ruimte"
            :error="errors.first('room')"
            :has-permission="true"
            :required="true"
          ></text-input>
          <div class="flex flex-wrap w-full md:w-1/2">
            <text-input class="w-1/2 pr-2 md:px-2" label="Opp." name="opp" type="text"
              v-model="source.amount"
              :has-permission="true"
            ></text-input>
            <select-input class="w-1/2" label="Eenheid"
              v-model="source.unit"
              :options="units"
              :has-permission="true"
            ></select-input>
          </div>
        </div>

        <select-input class="w-full" label="Verwijdermethode"
          v-model="source.remove_method"
          :options="removeMethods"
          :has-permission="true"
        ></select-input>

        <select-input class="w-full" label="Status"
          v-model="source.status"
          :options="statuses"
          :has-permission="true"
        ></select-input>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-tertiary btn-sm" @click="close">Cancel</button>
      <button type="submit" class="btn btn-primary btn-sm">Opslaan</button>
    </div>
  </base-form>
</template>

<script>
import SubjectService from '@/services/subject';
import SourceService from '@/services/source';
import BaseForm from '@/components/globals/BaseForm';
import TextInput from '@/components/inputs/Text';
import SelectInput from '@/components/inputs/Select';

import { EventBus } from '@/event-bus';
import { mapMutations } from 'vuex';
import { HIDE_MODAL } from '@/store/mutations.types';

export default {
  name: 'SourceModal',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    TextInput,
    SelectInput
  },
  data() {
    return {
      room: null,
      source: null,
      error: null,
      // Data for selectboxes
      units: [],
      removeMethods: [],
      statuses: []
    };
  },
  created() {
    const payload = this.clone(this.$store.state.modal.items);
    this.room = payload.room;
    this.source = this.room.sources[payload.index];

    this.fetchUnits();
    this.fetchRemoveMethods();
    this.fetchStatuses();
  },
  methods: {
    ...mapMutations('modal', {
      hide: HIDE_MODAL
    }),
    clone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    close() {
      this.$validator.reset();
      this.hide();
    },
    async fetchUnits() {
      try {
        const { data: response } = await SourceService.units();
        this.units = response.data;
      } catch (error) {
        this.units = null;
        this.error = error;
      }
    },
    async fetchRemoveMethods() {
      try {
        const { data: response } = await SourceService.removeMethods();
        this.removeMethods = response.data;
      } catch (error) {
        this.removeMethods = null;
        this.error = error;
      }
    },
    async fetchStatuses() {
      try {
        const { data: response } = await SourceService.statuses('source');
        this.statuses = response.data;
      } catch (error) {
        this.statuses = null;
        this.error = error;
      }
    },
    async beforeSend() {
      const result = await this.$validator.validateAll();
      if (result) this.save();
    },
    async save() {
      if (!this.$route.params.id) return;

      try {
        await SubjectService.saveSource(this.$route.params.id, this.room);
        EventBus.$emit('source-saved', this.room);
        this.close();
      } catch (error) {
        this.error = error;
      }
    }
  }
};
</script>

<style>
.modal-container .modal-body {
  overflow: unset;
}
</style>
